import ApiService from './../api/ApiService';
import Urls from './../api/Urls';
import Config from '../constants/Config';
import TicketSold from '../models/TicketSold';

export function getTicketSold(params) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.TICKET_SOLD_LIST,
        params: params,
        parser: ticketSoldDataParser,
    }).get();
}

function ticketSoldDataParser(data = {}) {
    return {
        ...data,
        result: (data.result || []).map(item => new TicketSold(item))
    }
}